// Only place that reads/writes the access token. It lives in localStorage (XSS-readable but short-lived); the long-lived refresh token stays in an httpOnly cookie out of JS reach.

const ACCESS_TOKEN_STORAGE_KEY = 'foundry.auth.accessToken';

export function getAccessToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setAccessToken(token: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
  } catch {
    // Storage may be full or disabled (private browsing). Sign-in still
    // succeeds — the next request will simply behave as anonymous.
  }
}

export function clearAccessToken(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  } catch {
    // Best-effort.
  }
}

export function isSignedIn(): boolean {
  return getAccessToken() !== null;
}
